
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import WhoWeServe from './components/WhoWeServe';
import ProductCategories from './components/ProductCategories';
import WhySonomaRoutes from './components/WhySonomaRoutes';
import HowItWorks from './components/HowItWorks';
import Trust from './components/Trust';
import FinalCTA from './components/FinalCTA';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <WhoWeServe />
      <ProductCategories />
      <WhySonomaRoutes />
      <HowItWorks />
      <Trust />
      <FinalCTA />
      <Footer />
    </div>
  );
}
